export const Options = {
    Salutation: [
        { text: "Frau", value: "0" },
        { text: "Herr", value: "1" },
        { text: "Divers", value: "2" },
    ],
    BecomingAwareThrough: [
        { text:"Mitarbeiterempfehlung",value:"Mitarbeiterempfehlung"},
        { text:"Stepstone.de",value:"Stepstone.de" },
        { text:"Indeed",value:"Indeed" },
        { text:"GoogleJobs",value:"GoogleJobs" },
        { text:"LinkedIn",value:"LinkedIn" },
        { text:"Messe",value:"Messe" },
        { text:"Zeitung",value:"Zeitung" },
        { text:"Kleinanzeigen (ehem. eBay)",value:"Kleinanzeigen (ehem. eBay)" },
        { text:"Supermarktanzeige",value:"Supermarktanzeige" },
        { text:"Ausbildung.de",value:"Ausbildung.de" },
        { text:"Studysmarter",value:"Studysmarter" },
        { text:"Sonstige",value:"Sonstige" },
    ]
}
